import {getLocalDateTime} from '@frontend/shared';
import {ProposalModel} from '../interfaces';

export const createProposal = (x: any, generation: number): ProposalModel => {
    const expectedDays = x.delivery?.expected.client.days;
    const guaranteedDays = x.delivery?.guaranteed.client.days;

    // Проверяем разницу между гарантированным и ожидаемым сроком
    const daysDifference = guaranteedDays - expectedDays;
    const shouldShowRange = daysDifference >= 4;

    return {
        key: `${x.webSupplierName}_${x.priceListIdentifier}_${x.rating}_${x.price}`,
        matchFilterProposal: x,
        brandName: x.brandName,
        source: !x.webSupplier ? 'лп' : 'вп',
        supplierName: x.supplierName,
        webSupplier: x.webSupplier,
        webSupplierName: x.webSupplierName,
        managementAcc: true, // признак управленческого учета поставщика, не приходит с бэка
        nds: true, // признак НДС, не приходит с бэка
        priceListIdentifier: x.priceListIdentifier,
        visiblePriceListIdentifier: x.visiblePriceListIdentifier,
        rating: x.rating || 0,
        isOfficialDealer: x.flags['official'],
        isReturnPossible: x.returnCondition !== 'impossible',
        multiplicity: x.multiplicity === 0 ? 1 : x.multiplicity,
        quantity: x.quantity,
        firstPrice: x.firstPrice,
        price: x.price,
        minPrice: x.minPrice,
        deliveryDays: x.delivery?.expected.client.days,
        deliveryDaysMax: shouldShowRange ? guaranteedDays : undefined,
        deliveryDate: getLocalDateTime(
            shouldShowRange ? x.delivery?.guaranteed.client.date : x.delivery?.expected.client.date
        ),
        sourceCross: 'Локальная база', // источник кросса, не приходит с бэка
        systemInfo: {
            commonExtraChargeIdx: x.systemInfo.commonExtraChargeIdx,
            additionalExtraChargesIdxs: x.systemInfo.additionalExtraChargesIdxs,
            deliveryIdx: x.systemInfo.deliveryIdx,
            originalPrice: x.systemInfo.originalPrice,
            removedReason: x.systemInfo.removedReason,
            priceList: x.systemInfo.priceList,
            rrpApplied: x.systemInfo.rrpApplied,
            salesCount: x.systemInfo.salesCount
        },
        extraCharges: x.extraCharges,
        deliveryInterval: x.deliveryInterval,
        delivery: x.delivery,
        requestedArticle: x.requestedArticle
    };
};
